import IconBase, { IconBaseProps } from "./IconBase";

const ShapesIcon = (props: IconBaseProps) => (
  <IconBase data-testid="ShapesIcon" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.353 16h5.292l-2.648-3.437L9.353 16zm8.117.39a1 1 0 0 1-.792 1.61H7.32a1 1 0 0 1-.792-1.61l4.676-6.076a1 1 0 0 1 1.584 0l4.681 6.076zM6 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
    />
  </IconBase>
);

export default ShapesIcon;
